import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { selectChatsState } from "../store/chats/selectors";
import { fetchChecklistByConversationId } from "../store/chats/thunks";

export const useChecklists = () => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { chatsByTenants, selectedChatId } = useSelector(selectChatsState);

  const selectedChat = useMemo(() => {
    return chatsByTenants?.[selectedTenantId]?.[selectedChatId];
  }, [selectedChatId, selectedTenantId, chatsByTenants]);

  useEffect(() => {
    if (
      selectedChatId &&
      !selectedChat?.checklists &&
      !selectedChat?.checkListLoading
    ) {
      dispatch(
        fetchChecklistByConversationId({
          conversation_id: selectedChat?.id,
          tenant_id: selectedTenantId,
        }),
      );
    }
  }, [selectedTenantId, selectedChatId, selectedChat, dispatch]);

  return {
    loading: selectedChat?.checkListLoading,
    checklists: selectedChat?.checklists || [],
    selectedTenantId,
    selectedChatId,
  };
};
